import React from 'react';
import { observer, inject } from 'mobx-react';
import { WithPickupsGridFilterHOC } from './index';
import GridSelectFilter from '../../../common/GridSelectFilter';

@inject('DispatchStore')
@observer
class PickupsGridFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPickupType: null,
    };
  }

  componentDidMount() {
    const { DispatchStore } = this.props;
    const defaultFilter = DispatchStore.pickupsFilter
      ? DispatchStore.pickupsFilter
      : this.props.defaultFilter;
    !DispatchStore.pickupsFilter &&
      DispatchStore.updatePickupsFilter(defaultFilter);
    this.filterPickups(true)(
      this.props.options.find((option) => option.value === defaultFilter.value)
    );
    this.props.stack.layoutManager.eventHub.on(
      'pickupsPanelfilterchanged',
      this.handleFilterChanged
    );
  }

  componentWillUnmount() {
    this.props.stack.layoutManager.eventHub.off(
      'pickupsPanelfilterchanged',
      this.handleFilterChanged
    );
  }

  handleFilterChanged = (option) => {
    this.filterPickups()(option);
  };

  filterPickups = (isPickupFilterMounted = false) => (option) => {
    if (this.state.selectedPickupType?.value !== option.value) {
      this.props.stack.layoutManager.eventHub.emit(
        `${this.props.headerId}_selectFilterSelected`,
        { option, isPickupFilterMounted }
      );
      this.setState({
        selectedPickupType: option,
      });
    }
  };

  render() {
    return (
      <GridSelectFilter
        value={this.state.selectedPickupType}
        onChange={this.filterPickups()}
        options={this.props.options}
      />
    );
  }
}

export default WithPickupsGridFilterHOC(PickupsGridFilter);
